import { SaleOpportunity } from '@/components/myCustomers/mySellers/interfaces';
import { getLeadRevenue } from '@/components/myCustomers/mySellers/LeadView.utils';

export const sumRevenues = (opportunities: SaleOpportunity[]): number =>
  opportunities.reduce<number>(
    (acc, { chargedFees, commission, price }) =>
      acc + getLeadRevenue(commission, price, chargedFees),
    0
  );
